import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';
import { Button } from '../Button';
import handsClap from '../../../assets/hands-clap.png';
import * as styles from './SuccessContent.css';
export var SuccessContent = function SuccessContent(_ref) {
  var additionalMessage = _ref.additionalMessage,
      onConfirm = _ref.onConfirm,
      text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "success-callback-content"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles['image'],
    src: handsClap
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement(ArticleHeading2, {
    as: "p",
    textAlign: "center",
    whiteSpace: "pre-line"
  }, text)), additionalMessage && /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement(ArticleParagraph1, {
    as: "p",
    textAlign: "center"
  }, additionalMessage)), /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm
  }, "\u041E\u043A, \u043F\u043E\u043D\u044F\u0442\u043D\u043E"));
};